{
  "version": 1,
  "asset_id": "8c13acd3-b4fc-49fa-9ffd-33fc2840aebb",
  "project_id": "01579873-aba5-45c2-b48e-0fe42afbbb35",
  "url": "/__l5e/assets-v1/8c13acd3-b4fc-49fa-9ffd-33fc2840aebb/icon.png",
  "r2_key": "a/v1/01579873-aba5-45c2-b48e-0fe42afbbb35/8c13acd3-b4fc-49fa-9ffd-33fc2840aebb/icon.png",
  "original_filename": "icon.png",
  "size": 139982,
  "content_type": "image/png",
  "created_at": "2026-06-16T18:44:32Z"
}
